import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";

export const EMISSIONS_API_REDUCER_KEY = "emissionsApi";

export const emissionsApi = createApi({
  reducerPath: EMISSIONS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["emission"],
  endpoints: (builder) => ({
    getEmissionsList: builder.query({
      query: ({ page, limit }) => ({
        url: `/emissions/?page=${page}&limit=${limit}`,
      }),
      providesTags: ["emission"],
    }),

    getEmissionsSector: builder.query({
      query: () => ({
        url: "/emissions/emission-sectors/?limit=20",
      }),
      providesTags: ["emission"],
    }),
  }),
});

export const { useGetEmissionsListQuery, useGetEmissionsSectorQuery } =
  emissionsApi;
